export default (
  state = {
    name: '',
    flag: '',
  },
  action
) => {
  switch (action.type) {
    case "HANDLE_FOCUS":
      const focusedState = {
        [`${action.inputType}Active`]: true,
        [`${action.inputType}Blurred`]: false,
      }
      const newState = {
        ...state,
        ...focusedState
      }
      return newState;
    case "HANDLE_CHANGE":
      const newInput = {
        [`${action.inputType}Active`]: true,
        [`${action.inputType}`]: action.value,
      }
      const updatedState = {
        ...state,
        ...newInput
      }
      return updatedState;
    case "HANDLE_BLUR":
      const determineValid = action.inputType === 'name'
        ? (action.value.length <= 8 && action.value.length)
        : action.value
      const determineActive = action.value ? true : false
      const blurredInput = {
        [`${action.inputType}Blurred`]: true,
        [`${action.inputType}Valid`]: determineValid,
        [`${action.inputType}Active`]: determineActive,

      }
      const blurredState = {
        ...state,
        ...blurredInput
      }
      return blurredState;

    case "IS_POSTING_UNIID":
      return {
        ...state,
        isPostingUniid: true,
      }
    case "UNIID_SUCCESS":
      return {
        ...state,
        isPostingUniid: false,
        success: true
      }
    case "UNIID_FAILURE":
      return {
        ...state,
        isPostingUniid: false,
        error: true
      }

    default:
      return state;
  }
};
